'use client';
import React from 'react';
import { Box, Flex, Skeleton, SkeletonText } from '@chakra-ui/react';

const TestimonialCardSkeleton = () => {
  return (
    <Box
      width="100%"
      padding={{ base: 4, tablet: 6 }}
      borderWidth="1px"
      borderColor="neutral.10"
      borderRadius="8px"
      backgroundColor="common.100"
      height="100%"
    >
      <Flex flexDirection="column" width="100%" gap={{ base: 3, tablet: 4 }} height="100%">
        <Skeleton height={{ base: '200px', tablet: '248px' }} width="100%" borderRadius="8px" />

        <Flex justifyContent="space-between" alignItems="center">
          <Flex gap={2} alignItems="center">
            <Skeleton height="16px" width="120px" borderRadius="4px" />
          </Flex>
          <Skeleton height="16px" width="80px" borderRadius="4px" />
        </Flex>

        <Flex gap={3} alignItems="flex-start">
          <Skeleton
            height={{ base: '24px', tablet: '32px' }}
            width={{ base: '24px', tablet: '32px' }}
            borderRadius="8px"
          />
          <Skeleton height={{ base: '20px', tablet: '24px' }} width="70%" borderRadius="4px" />
        </Flex>

        <SkeletonText noOfLines={4} />

        <Flex justifyContent="space-between" alignItems="center" width="100%" mt="auto">
          <Flex gap={3} alignItems="center">
            <Skeleton height="32px" width="32px" borderRadius="50%" />
            <Skeleton height="16px" width="100px" borderRadius="4px" />
            <Flex gap={1}>
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} height="16px" width="16px" borderRadius="4px" />
              ))}
            </Flex>
          </Flex>
          <Skeleton height="16px" width="80px" borderRadius="4px" />
        </Flex>

        <Box height="1px" width="100%" backgroundColor="neutral.10" />

        <Flex
          justifyContent="space-between"
          alignItems={{ base: 'flex-start', tablet: 'center' }}
          width="100%"
          flexDirection={{ base: 'column', tablet: 'row' }}
          gap={{ base: 2, tablet: 0 }}
        >
          <Flex gap={2} alignItems="center">
            <Skeleton height="16px" width="60px" borderRadius="4px" />
            <Skeleton height="16px" width="80px" borderRadius="4px" />
          </Flex>
          <Flex gap={2} alignItems="center">
            <Skeleton height="16px" width="80px" borderRadius="4px" />
            <Skeleton height="16px" width="80px" borderRadius="4px" />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

const CustomerTestimonialsSwiperSkeleton = () => {
  return (
    <Box width="100%" position="relative">
      {/* Cards container */}
      <Flex width="100%" justifyContent="space-between" gap={{ base: 4, tablet: 6 }}>
        <Box width="100%" position="relative">
          <TestimonialCardSkeleton />

          <Box
            position="absolute"
            top="15%"
            right="-13px"
            height="70%"
            width="1px"
            backgroundColor="neutral.10"
            display={{ base: 'none', tablet: 'block' }}
            zIndex={1}
          />
        </Box>

        <Box width="100%" display={{ base: 'none', tablet: 'block' }} position="relative">
          <TestimonialCardSkeleton />

          <Box
            position="absolute"
            top="15%"
            right="-13px"
            height="70%"
            width="1px"
            backgroundColor="neutral.10"
            display={{ base: 'none', desktop: 'block' }}
            zIndex={1}
          />
        </Box>

        <Box width="100%" display={{ base: 'none', desktop: 'block' }}>
          <TestimonialCardSkeleton />
        </Box>
      </Flex>

      <Flex alignItems="center" gap={6} justifyContent="center" width="100%" marginTop={6}>
        <Skeleton height="36px" width="36px" borderRadius="full" />

        <Flex alignItems="center" gap={1}>
          {[...Array(5)].map((_, idx) => (
            <Skeleton
              key={idx}
              height="4px"
              width={idx === 0 ? '32px' : '8px'}
              borderRadius={idx === 0 ? '4px' : 'full'}
            />
          ))}
        </Flex>

        <Skeleton height="36px" width="36px" borderRadius="full" />
      </Flex>
    </Box>
  );
};

export default CustomerTestimonialsSwiperSkeleton;
